export const onRequest = {
    default: true,
    b2bwebolympia: true,
    b2bweberoski: true,
    b2bwebdawson: true
};



// WEBPACK FOOTER //
// ./src/defaultValues/onRequest.js